// db.ts
import Dexie, { Table } from 'dexie';
import {ImgType} from "../services/img.service";

export interface UserImage {
    userID: string;
    type: ImgType;
    image: Blob;
}

export class AppDB extends Dexie {
    userAvatars!: Table<UserImage, string>;

    constructor() {
        super('SMMImageCacheDB');
        this.version(1).stores({
            userAvatars: 'userID, type',
        });
    }

    async putImage(type_arg: ImgType, usrID:string, img_arg: Blob):Promise<string> {
        // use put. If image  type for usrID already exists, is being updated else is being added
        return db.userAvatars.put({
            userID: usrID,
            type: type_arg,
            image: img_arg,
        });
    }

    async deleteImage(usrID:string, type_arg: ImgType):Promise<number> {
        return db.userAvatars.where("userID").equals(usrID).and(usrImg => usrImg.type == type_arg ).delete();
    }

    async getImage(usrID:string, type: ImgType):Promise<Blob> {
      const usrImgArray:UserImage [] = await db.userAvatars.where("userID").equals(usrID).and(usrImg => usrImg.type == type).toArray();
      if(usrImgArray.length > 0){
          return (usrImgArray[0].image);
      }
      else{
          //cache miss
          return undefined;
      }
    }

    async updateImage (usrID:string, type: ImgType, img: Blob, ):Promise<boolean> {
        const itemsToUpdate = await db.userAvatars.where("userID").equals(usrID).and(usrImg => usrImg.type == type).toArray();
        let updated: number = 0;
        for ( const user of itemsToUpdate ) {
           let result =  await db.userAvatars.update(user.userID, {image: img});
           updated+=result;
        }
        return (updated > 0);
    }

    deleteDatabase() {
        db.delete()
            .then( rez => {
                console.log("Database removed");
            })
            .catch( err => {
            console.error(err);
        });

    }

    static getDB():AppDB{
        if(! db.isOpen()){
            db.open();
        }
        return db;
    }
}

const db = new AppDB();
